module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Video"
  }, [_c('md-card', [_c('md-card-actions', {
    directives: [{
      name: "md-ink-ripple",
      rawName: "v-md-ink-ripple"
    }]
  }, [_c('div', {
    staticClass: "md-subhead"
  }, [_c('span', [_vm._v("Base Config / サンプル")])])]), _vm._v(" "), _c('md-card-media', [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    },
    on: {
      "play": function($event) {
        _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        _vm.onPlayerPause($event)
      },
      "ended": function($event) {
        _vm.onPlayerEnded($event)
      },
      "loadeddata": function($event) {
        _vm.onPlayerLoadeddata($event)
      },
      "waiting": function($event) {
        _vm.onPlayerWaiting($event)
      },
      "playing": function($event) {
        _vm.onPlayerPlaying($event)
      },
      "timeupdate": function($event) {
        _vm.onPlayerTimeupdate($event)
      },
      "canplay": function($event) {
        _vm.onPlayerCanplay($event)
      },
      "canplaythrough": function($event) {
        _vm.onPlayerCanplaythrough($event)
      },
      "ready": _vm.playerReadied,
      "statechanged": function($event) {
        _vm.playerStateChanged($event)
      }
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00628340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = 475
// module chunks = 1